export default __webpack_public_path__ + "static/ClimateChangeGraz_Logo_medium-30611fbde57ed8eea71375c32515157d.jpg";